import React from 'react';
import techIcons from '../../../js/portfolio/techstack';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TechStack = ({ stack }) => (
  <div className="tech-stack">
    {stack.map((tech, index) => {
      const icon = techIcons[tech];

      return (
        <div className="tech-item" key={index}>
          {icon.image ? (
            <img src={icon.image} alt={icon.name} className="tech-logo" />
          ) : (
            <FontAwesomeIcon icon={icon.icon} size="2x" className="tech-logo" />
          )}
          <span className="tooltip">{icon.name}</span>
        </div>
      );
    })}
  </div>
);

export default TechStack;
